<button class="s11-icon-circular-border">
  @if (userUrl) {
    <img
      alt="user-icon"
      [src]="userUrl"
      class="s11-icon-circular-content"
      (click)="goToProfile()" />
  } @else {
    <img
      alt="user-icon"
      src="./../../../hvtdp.png"
      (click)="goToProfile()"
      class="s11-icon-circular-content" />
  }
</button>
